import { Helmet } from "react-helmet-async";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const faqs = [
  {
    q: "כמה זמן לוקח לאתר נזילה בגג?",
    a: "ברוב המקרים אנחנו מאתרים את מקור הנזילה בביקור אחד של 30–60 דקות, בעזרת ציוד מקצועי וניסיון של מעל 13 שנה. במקרים מורכבים נדרשת בדיקה נוספת בגשם או בדיקת לחץ.",
  },
  {
    q: "האם אתם נותנים אחריות על תיקון נזילות?",
    a: "כן. כל תיקון נזילה מקבל אחריות מלאה לחורף שלם. אם הנזילה חוזרת באותו מוקד – אנחנו חוזרים ומתקנים ללא עלות נוספת.",
  },
  {
    q: "באילו אזורים אתם נותנים שירות?",
    a: "אנחנו פועלים בעיקר בחיפה, הקריות (ביאליק, אתא, מוצקין, ים), נשר, טירת כרמל, עכו, יקנעם עילית והסביבה. לפרויקטים גדולים מגיעים גם מחוץ לאזור.",
  },
  {
    q: "מתי כדאי להחליף מרזבים?",
    a: "כשהמרזבים חלודים, סדוקים, מתנתקים מהקיר או שהמים גולשים מהם בגשם – זה הזמן. החלפה מונעת חדירת רטיבות לקירות ונזק לבסיס המבנה.",
  },
];

const FAQSection = () => {
  const ref = useScrollReveal();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="py-20 bg-background" ref={ref}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-10 animate-on-scroll">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            שאלות <span className="text-primary">נפוצות</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            התשובות לשאלות שאנחנו הכי הרבה נשאלים על נזילות, מרזבים ופחחות
          </p>
        </div>

        <Accordion type="single" collapsible className="animate-on-scroll">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-right font-bold text-foreground hover:text-primary">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
